export const METRIC_COHORT_TOTAL_USERS = "cohortTotalUsers";
export const METRIC_EVENT_COUNT = "eventCount";
export const METRIC_TOTAL_USERS = "totalUsers";
export const METRIC_NEW_USERS = "newUsers";
export const METRIC_ACTIVE_1_DAY_USERS = "active1DayUsers";
export const METRIC_ACTIVE_7_DAY_USERS = "active7DayUsers";
export const METRIC_ACTIVE_28_DAY_USERS = "active28DayUsers";
export const METRIC_VIEWS = "screenPageViews";
export const METRIC_PAGE_VIEWS = "page_views";
